
import {defineComponent, onBeforeMount, ref, Ref} from "vue";
import {useStore} from "vuex";

export default defineComponent({
  setup() {
    const store = useStore();
    const message: Ref<string> = ref("");
    const buttonsText: Ref = ref();

    onBeforeMount(() => {
      message.value = store.getters["alert_box_module/message"];
      buttonsText.value = store.getters["alert_box_module/buttonsText"];
    });

    const continueAction = async (): Promise<void> => {
      await store.dispatch("alert_box_module/shouldContinue", true);
      await close();
    };

    const close = async (): Promise<void> => {
      await store.dispatch("alert_box_module/close");
    };

    return {
      continueAction,
      message,
      buttonsText,
    };
  },
});
